import { axiosInstance } from '../../utils';
import { IAudioCreation } from '../../@types';

interface Payload {
  id: string;
}

export const deleteCreatedAudio = async ({ id }: Payload): Promise<IAudioCreation> => {
  const res = await axiosInstance.delete(`/api/audios/audio-build/${id}`);
  return res.data;
};
